import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

const GroupAccountApiUrl = (groupId: string, accountId: string) =>
  `/api/v2/groups/${groupId}/accounts/${accountId}`;
const AccountApiUrl = (accountId: string) => `/api/admin/accounts/${accountId}`;

interface GetAccountResponse {
  item: Account;
}

@Injectable()
export class AccountEditService {
  constructor(private http: HttpClient) {}

  getAccount(account: Account, group: Partial<Group> = {}) {
    const groupId = group._id;
    const url = groupId
      ? GroupAccountApiUrl(groupId, account._id)
      : AccountApiUrl(account._id);
    return this.http
      .get(url)
      .pipe(map((response: GetAccountResponse) => response.item));
  }

  updateAccount(account: Account, update: any) {
    return this.http.patch(AccountApiUrl(account._id), update);
  }
}
